const prefixClass = 'cfmoto-dialog';
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'alert'
    },
    title: {
      type: String,
      default: '信息提示'
    },
    message: {
      type: String,
      default: ''
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: '确&nbsp;定'
    },
    cancelText: {
      type: String,
      default: '取&nbsp;消'
    },
    onCancel: {
      type: Function
    },
    onConfirm: {
      type: Function
    },
    top: {
      type: String,
      default: '50%'
    },
    left: {
      type: String,
      default: '50%'
    }
  },
  emits: ['update:modelValue'],
  components: {},
  data() {
    return {
      interval: 0,
      visible: this.modelValue,
      showTime: 0,
      isClosed: false
    };
  },
  computed: {
    classes() {
      return `${prefixClass} ${prefixClass}-${this.type || 'alert'}`;
    },
    iconClass() {
      return {
        warning: 'iconfont-warning',
        success: 'iconfont-chenggong',
        fail: 'iconfont-shibai',
        error: 'iconfont-cry',
        msg: 'iconfont-warning'
      }[this.type];
    },
    styles() {
      const {
        top,
        left
      } = this;
      return {
        top,
        left
      };
    }
  },
  methods: {
    show() {
      const $content = this.$el.querySelector('.dialog-containner');
      this.isClosed = false;
      this.visible = true;
      this.$nextTick(() => {
        const width = `${-$content.clientWidth / 2}px`;
        const height = `${-$content.clientHeight / 2}px`;
        this.styles.left = '50%';
        this.styles.top = '50%';
        this.styles.marginLeft = width;
        this.styles.marginTop = height;
      });
      if (this.showTime) {
        this.closeMyself();
      }
    },
    destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      // this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close() {
      this.isClosed = true;
      this.visible = false;
      // this.$el.addEventListener('transitionend', this.destroyElement);
      this.destroyElement();
    },
    closeMyself() {
      const timer = setTimeout(() => {
        if (this.isClosed) {
          return;
        }
        this.destroyElement();
        clearTimeout(timer);
      }, this.showTime);
    },
    handleCancel() {
      if (this.onCancel) {
        this.onCancel(this);
      }
      this.close();
    },
    handleConfirm() {
      if (this.onConfirm) {
        this.onConfirm(this);
      }
      this.close();
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {
    modelValue() {
      this.visible = this.modelValue;
    },
    visible() {
      this.$emit('update:modelValue', this.visible);
    }
  }
};